import { EditPageButtonView } from "@softmax/product-ux/editor";

import { useEditModeMaybe } from "./use-edit-mode-maybe";

export function EditToggleButton() {
  const mode = useEditModeMaybe();

  if (!mode?.canEdit || mode.editing) return null;

  return <EditPageButtonView onEdit={mode.enterEditing} />;
}
